"use client"

import { createContext } from "react"

export const ImpressionsTrackingScope = createContext(true)
